import React from 'react'
import RightHandSide from '../../Common/Services/RightHandSide'
import AboutInnBanContent from '../../Common/InnerBanner/AboutInnBanContent';
import { AboutInnerBanner } from '../../Common/InnerBanner/AboutInnerBanner';
import HeadContent from '../BlogContent/HeadContent';
import HeadDesign from '../BlogContent/HeadDesign';
import Info from '../BlogContent/Info';
import List from '../BlogContent/List';
import InfoContent from '../BlogContent/InfoContent';
import ListContent from '../BlogContent/ListContent';
import RecentBlogsList from '../BlogContent/RecentBlogsList';
const Blog14 = () => {
    const {image, heading, pageName} = AboutInnBanContent.BlogDetails;
     const {bg, para, date, blogHeading} = HeadContent.blog_14;

    const {title, p} = InfoContent.Blog_14.one;
    const {title2, p2} = InfoContent.Blog_14.two;
    const {title3, p3} = InfoContent.Blog_14.three;
    const {title4, p4} = InfoContent.Blog_14.four;
     const {Ctitle, Cp} = InfoContent.Blog_14.conclusion;

    const {liss1} = ListContent.Blog_14.L1;
    
  return (
    <>
    <AboutInnerBanner image={image} heading={heading} pageName={pageName} />

    <div className="blog-area pt-100 pb-70">
        <div className="container">
            <div className="row">
                <div className="col-lg-8">
                    <HeadDesign bg={bg} para={para} date={date} blogHeading={blogHeading} />
                    <Info title={title} p={p} />
                    <Info title={title2} p={p2} />

                    <List liss={liss1} />

                    <Info title={title3} p={p3} />
                    <Info title={title4} p={p4} />
                    

                    <Info title={Ctitle} p={Cp} />
                </div>
                <div className="col-lg-4">
                    <RecentBlogsList/>
                    <RightHandSide/>
                </div>
            </div>
        </div>
    </div>
    </>
  )
}

export default Blog14